// Portfolio images — REPLACE WITH YOUR OWN PHOTOS
// To replace: drop your photos into /app/frontend/public/portfolio/
// and update the src paths below, or keep using external URLs.
// Each item: { src, tall: boolean (optional) }

export const portfolioImages = [
  "/portfolio/slot-01.jpg", // 1 - Business partnership meeting
  "/portfolio/slot-02.jpg", // 2 - Palm oil mill partner visit
  "/portfolio/slot-07.jpg", // 3 - Pre-export preparation site
  "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?auto=format&fit=crop&w=1200&q=80",
  "https://images.unsplash.com/photo-1581094288338-2314dddb7ece?auto=format&fit=crop&w=1200&q=80",
  "https://images.unsplash.com/photo-1544531585-9847b68c8c86?auto=format&fit=crop&w=1200&q=80",
  "/portfolio/slot-08.jpg", // 7 - Customs container inspection
  "/portfolio/slot-03.jpg", // 8 - Bulk carrier loading
  "https://images.unsplash.com/photo-1542838132-92c53300491e?auto=format&fit=crop&w=1200&q=80",
];
